/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Slide3alt1Inputs */

const he_extension_slide3alt1 = /** @type {(inputs: Extension_Slide3alt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תוסף PriceDrop מציג התראות מחירים חכמות`)
};

const en_extension_slide3alt1 = /** @type {(inputs: Extension_Slide3alt1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PriceDrop extension showing smart price alerts`)
};

/**
* | output |
* | --- |
* | "PriceDrop extension showing smart price alerts" |
*
* @param {Extension_Slide3alt1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_slide3alt1 = /** @type {((inputs?: Extension_Slide3alt1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Slide3alt1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_slide3alt1(inputs)
	return en_extension_slide3alt1(inputs)
});
export { extension_slide3alt1 as "extension_slide3Alt" }